import React from 'react';
import ShoppingCartModal from "../../features/shoppingCart/ui/modal/ShoppingCartModal";
import {StyledTitleSection} from "../../shared/ui/typography/style";
import ProductListGrid from "../../shared/ui/productListGrid/ProductListGrid";
import GoodsCard from "../../entities/goods/ui/card/GoodsCard";
import {GoodsType} from "../../entities/goods/model/types/goods-type";
import PreviewGoods from "../../entities/goods/ui/preview/PreviewGoods";

const ShoppingCartWidget = () => {
    const recommend: GoodsType[] = [
        {
            "additional_name_by_firm": {
                "22": "Стеновая панель S516 Антик 3050х600х10 мм Односторонняя LUXEFORM"
            },
            "band": false,
            "code_firms": "6:LM-00062762 , 1:43576 , 15:_ , 31:43576",

            "description": "S 516 Antique LUXEFORM - wall panel measuring 3050*600*10 mm. Color: brown (close to brown). Texture: aged wood with a worn effect. The panel is ideal for creating a unique interior with an emphasis on vintage style.",
            "hash_md5": "e740da47b8646c74fabb0d598fd4929d",
            "id": 43576,
            "name": "S 516 Antique LUXEFORM 3050 * 600 * 10 wall panel",
            "part": true,
            "producer_id": 43576,
            "producer_name": [
                2572796115
            ],
            "tags": "",
            "tovar": false,
            "type_material": 83,
            "type_material_name": "wall panels",

            "ws_available_for_sale_by_firm": [
                1,
                6,
                15,
                31
            ],
            price: 123,
            old_price: 100,
            currency: "$",
            created_at: new Date(),
            updated_at: new Date(),
        },
        {
            "additional_name_by_firm": {
                "22": "Стеновая панель S516 Антик 3050х600х10 мм Односторонняя LUXEFORM"
            },
            "band": false,
            "code_firms": "6:LM-00062762 , 1:43576 , 15:_ , 31:43576",

            "description": "S 516 Antique LUXEFORM - wall panel measuring 3050*600*10 mm. Color: brown (close to brown). Texture: aged wood with a worn effect. The panel is ideal for creating a unique interior with an emphasis on vintage style.",
            "hash_md5": "e740da47b8646c74fabb0d598fd4929d",
            "id": 43576,
            "name": "S 516 Antique LUXEFORM 3050 * 600 * 10 wall panel",
            "part": true,
            "producer_id": 43576,
            "producer_name": [
                2572796115
            ],
            "tags": "",
            "tovar": false,
            "type_material": 83,
            "type_material_name": "wall panels",

            "ws_available_for_sale_by_firm": [
                1,
                6,
                15,
                31
            ],
            price: 123,
            old_price: 100,
            currency: "$",
            created_at: new Date(),
            updated_at: new Date(),
        },
        {
            "additional_name_by_firm": {
                "22": "Стеновая панель S516 Антик 3050х600х10 мм Односторонняя LUXEFORM"
            },
            "band": false,
            "code_firms": "6:LM-00062762 , 1:43576 , 15:_ , 31:43576",

            "description": "S 516 Antique LUXEFORM - wall panel measuring 3050*600*10 mm. Color: brown (close to brown). Texture: aged wood with a worn effect. The panel is ideal for creating a unique interior with an emphasis on vintage style.",
            "hash_md5": "e740da47b8646c74fabb0d598fd4929d",
            "id": 43576,
            "name": "S 516 Antique LUXEFORM 3050 * 600 * 10 wall panel",
            "part": true,
            "producer_id": 43576,
            "producer_name": [
                2572796115
            ],
            "tags": "",
            "tovar": false,
            "type_material": 83,
            "type_material_name": "wall panels",

            "ws_available_for_sale_by_firm": [
                1,
                6,
                15,
                31
            ],
            price: 123,
            old_price: 100,
            currency: "$",
            created_at: new Date(),
            updated_at: new Date(),
        },
    ]
    return (
        <>
            <ShoppingCartModal key={''}
                               recommendationsSlot={
                                   <>
                                       <StyledTitleSection>С этим <span>покупают</span></StyledTitleSection>
                                       <ProductListGrid>
                                           {recommend.map(item => (<GoodsCard goods={item}
                                                                              slotPreview={<PreviewGoods/>}

                                           />))}
                                       </ProductListGrid>
                                   </>
                               }
            />
        </>
    );
};

export default ShoppingCartWidget;